function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*jshint esversion: 8 */
import { ArgumentException } from "./Exceptions";
import { ArgumentTypeException } from "./Exceptions";

var _getKey = function _getKey(key) {
  return "mpp-widgets_".concat(key);
};
/**
 * Static storage wrapper class. Provides get, set and clear abilities
 */


export var SessionStorageManager = /*#__PURE__*/function () {
  function SessionStorageManager() {
    _classCallCheck(this, SessionStorageManager);
  }

  _createClass(SessionStorageManager, null, [{
    key: "setItem",
    value:
    /**
     * Sets item in storage under provided key name
     * @param {string} key Key under which item is stored
     * @param {object} item Item to be stored
     * @throws {ArgumentException}
     * @throws {ArgumentTypeException}
     */
    function setItem(key, item) {
      if (!key) {
        throw new ArgumentException("key");
      }

      if (typeof key !== "string") {
        throw new ArgumentTypeException("key");
      }

      if (!!window.sessionStorage && !!window.sessionStorage.setItem) {
        var fullKey = _getKey(key);

        window.sessionStorage.setItem(fullKey, item);
      }
    }
    /**
     * Gets item from storage, if not available returns null
     * @param {string} key Key under which item is stored
     * @returns {object} Item object if available, otherwise returns null
     * @throws {ArgumentException}
     * @throws {ArgumentTypeException}
     */

  }, {
    key: "getItem",
    value: function getItem(key) {
      if (!key) {
        throw new ArgumentException("key");
      }

      if (typeof key !== "string") {
        throw new ArgumentTypeException("key");
      }

      var item = null;

      if (!!window.sessionStorage && !!window.sessionStorage.getItem) {
        var fullKey = _getKey(key);

        item = window.sessionStorage.getItem(fullKey) || null;
      }

      return item;
    }
    /**
     * Clears all "context" items in sessionStorage
     */

  }, {
    key: "clear",
    value: function clear(startsWith) {
      if (!!window.sessionStorage && !!window.sessionStorage.removeItem) {
        var storageKeys = Object.keys(window.sessionStorage);

        if (!!storageKeys.length) {
          var searchFor = _getKey(startsWith);

          for (var key in storageKeys) {
            if (!!key) {
              var keyValue = storageKeys[key];

              if (!!keyValue && !!keyValue.startsWith && !!keyValue.startsWith(searchFor)) {
                window.sessionStorage.removeItem(keyValue);
              }
            }
          }
        }
      }
    }
  }]);

  return SessionStorageManager;
}();